import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import GridTemplateColumns from './GridTemplateColumns';
import ClientProvider from './client';
export default createDemo(import.meta.url, GridTemplateColumns, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/grid/demos/template-columns/GridTemplateColumns.tsx",
    "fileName": "GridTemplateColumns.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          bgcolor: '#fff',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function GridTemplateColumns() {\n  return (\n    <div style={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}>\n        <Item>1</Item>\n        <Item>2</Item>\n        <Item>3</Item>\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 42,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          bgcolor: '#fff',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          p: 1,\n          m: 1,\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function GridTemplateColumns() {\n  return (\n    <div style={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}>\n        <Item>1</Item>\n        <Item>2</Item>\n        <Item>3</Item>\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "display"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "grid",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "gridTemplateColumns"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "repeat(3, 1fr)",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">1</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 37
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">2</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 38
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">3</",
              [
                "span",
                "pl-c1 di-jsx",
                "Item"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 39
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 42,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
